
import styled from "styled-components";

const ReviewStyle = styled.div`
.review-section {
    padding: 174px 0 0;
     h3 {
    color: var(--green);
    font-family: var(--inte-BD);
    text-align: center;
    padding: 0 0 34px;
    font-size: 45px;
}
 p {
    font-size: 22px;
    text-align: center;
    font-family: var(--common-font);
    color: #000;
    font-weight: 500;
}
.own-review div {
    color: #000;
    text-align: center;
    padding: 11px;
    font-size: 24px;
    font-family: var(--common-font);
    font-weight: 800;
}
.own-review-par {
    max-width: 920px;
    margin: 0 auto;
}
.own-review-par p {
    margin-bottom: 20px;
}
}
.reviews-data {
    max-width: 683px;
    margin: 36px auto;
    @media(max-width:568px){
    max-width: 74%;
    }
}
 .reviews-data input {
    border-radius: 25px;
    height: 40px;
    font-size: 19px;
    padding: 0 4px;
}
 .reviews-data form select {
    border-radius: 0;
    box-shadow: inset 0 0 10px #ddd;
    font-weight: 600;
    padding: 0 4px;
    margin-bottom: 9px;
}
.main_div {
    background: #ddd;
}
.reviews-data form .mb-3.form-check.field-class label {
    font-size: 18px;
    color: #000;
    font-weight: 500;
}
.reviews-data form textarea.form-control {
    height: 150px;
    border-radius: 26px;
    margin: 10px 0 0;
}
.reviews-data form button.btn-primary {
    border-radius: 30px;
    background-color: var(--green);
    font-size: 20px;
    color: #ffffff;
    font-weight: bold;
    font-family: var(--exo);
    padding: 13px 50px 6px;
    margin: 0 auto;
    text-transform: uppercase;
}
.reviews-data .form-check.field-class:nth-child(4) {
    margin: 0;
}
.reviews-data .form-check.field-class:nth-child(5) {
    margin: 0 0 10px;
}
.reviews-data span.MuiRating-root.MuiRating-sizeMedium.MuiRating-readyOnly span {
    padding: 0 6px 0 0;
    font-size: 25px;
}
.reviews-data span.MuiRating-root.MuiRating-sizeMedium.MuiRating-readyOnly span svg {
    stroke: 1px solid #ddd;
    stroke: darkgray;
}
.btn-submit {
    text-align: center;
}
.review_section { 
        .rating_section_content {
            text-align: center;
            justify-content: center;
            gap:40px;
            @media (max-width:767px){
                gap:15px;
                flex-wrap:wrap;
            }

            .contain-bx {
                p {
                    font-size: 24px !important;
                    line-height:32px;
                }
            }
        }
}
.review_section .title_of_review {
      font-size: 13px !important;
    }
    .review_section .product_name,
    .review_section .rating_section {
      width: 100%;
    }
    .review_section .contain-bx.prplbx {
    border-radius: 26px;
    background-image: linear-gradient(90deg,#e40685 0%,#bd1b86 21%,#632e8a 100%);
}
.review_section .contain-bx.orange-bx {
    border-radius: 26px;
    background-image: linear-gradient(90deg,#fec90b 0%,#e94f24 100%);
}
.review_section  .contain-bx.gree-bx {
    border-radius: 26px;
    background-image: linear-gradient(90deg,#20a4dd 0%,#1ea3b6 24%,#25a07b 100%);
}
.review_section  .contain-bx {
    /* max-width: 270px; */
    height: 220px;
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    text-align: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-content: center;
    -ms-flex-line-pack: center;
    align-content: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
    margin-bottom: 40px;
    @media (max-width:1023px){
    max-width: 260px;
    height: 260px;
    }
    @media (max-width:991px){
    max-width: 220px;
    height: 220px;
    margin-bottom: 65px;
    }
    @media (max-width:568px){
    max-width:320px;
    height: auto;
    margin-bottom: 40px;
    }
}
.review_section {
    margin: 80px 0;
}
.review_section .contain-bx:before {
    content: "";
    position: absolute;
    top: 100%;
    right: 70px;
    width: 0;
    height: 0;
    border-top: 42px solid #812888;
    border-right: 42px solid transparent;
}
.review_section  .contain-bx.gree-bx:before {
    border-top: 42px solid #22a190;
}
.review_section .contain-bx.orange-bx:before {
    border-top: 42px solid #ed6a1e;
}
.review_section .contain-bx {

    color: #fff;

}
.review_section span.MuiRating-root.MuiRating-sizeMedium.MuiRating-readyOnly {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    justify-content: center;
    padding: 10px;
}
.review_section span.MuiRating-root.MuiRating-sizeMedium.MuiRating-readyOnly span {
    font-size: 20px;
    color: #fff;
    padding: 0 2px;
}
.reviews-data span.MuiRating-root.MuiRating-sizeMedium.MuiRating-readyOnly {
    justify-content: flex-start;
    margin: 0;
}
.review_section .rating_section_content .contain-bx p {
    font-size: 18px !important;
    line-height: 24px;
}
.form-control {
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 31px;
}
.reviews-data form select {
    border-radius: 18px;
    box-shadow: inset 0 0 10px #ddd;
    font-weight: 600;
    padding: 0 4px;
    margin-bottom: 9px;
}
.error-show{
    color: red;
    font-size: 14px;
}
    .message-show {
        display: flex;
        justify-content: center;
        font-size: 22px;
        color: green;
        padding-top: 17px;
    }
    .img {
    width: 100%;
}
.images-sections img {
    width: 100%;
    margin-bottom: -136px;
}



// 20 march 25


.rating_section_content .slick-slide>div {
    padding-inline: 8px;
}
.rating_section_content .slick-slide>div {
    padding-inline: 8px;
}
.rating_section_content button.slick-arrow:before {
    color: #000;
}
.rating_section_content button.slick-arrow {
    width: 30px;
    height: 30px;
    display: flex !important;
    justify-content: center;
    align-items: center;
}
.rating_section_content button.slick-arrow::before {
    font-size: 30px;
    top: -5px;
    position: relative;
}
`
export default ReviewStyle;